import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, accessToken) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    headers: { accesstoken: accessToken },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function renameWatchlist(list_name, new_list_name, description, accessToken) {
  const data = await fetchAPI(
    `mutation { renameWatchlist(name: "${list_name}", new_name: "${new_list_name}", description:"${description || ''}") { status }}`, accessToken
  )
  return data
}

